module.exports = __webpack_public_path__ + "packs/media/bundles/Admin/AdminDoc-d5b2749ac91adba414c537a2f548f3bf.md";